export default "__VITE_ASSET__C_EIYuUl__"